/*
 * Copyright Huesik (c) 2019.
 */

export default {
  objectToQueryString (data) {
    const str = []
    for (let p in data)
      if (data.hasOwnProperty(p)) {
        str.push(encodeURIComponent(p) + '=' + encodeURIComponent(data[p]))
      }
    return str.join('&')
  }
}
